import Http from '../../../core/Http';

/**
 * 공통(Common) API — 레이아웃·푸터 등 사이트 공통 영역용
 */

// --- 푸터 통계 (GLOW 테마) ---

/**
 * 푸터 통계 섹션 데이터 조회 (DB/백엔드 연동)
 * GET /api/comm/footer-stats
 *
 * @returns {Promise<Array<{ value: string, label: string, valueSuffix?: string, valueSuffixColor?: string }>>}
 */
export const fetchFooterStats = async () => {
  try {
    const data = await Http.get('/api/comm/footer-stats');
    const d = data || {};
    const list = Array.isArray(d.statistics) ? d.statistics : [];
    return list.length ? list.map(mapFooterStatFromApi) : getFooterStatsFallback();
  } catch (err) {
    console.warn('[commApi] fetchFooterStats failed, using fallback:', err?.message);
    return getFooterStatsFallback();
  }
};

function mapFooterStatFromApi(item) {
  return {
    value: item.value ?? '',
    label: item.label ?? '',
    valueSuffix: item.valueSuffix ?? undefined,
    valueSuffixColor: item.valueSuffixColor ?? '#fbbf24'
  };
}

/** API 미구현/실패 시 사용할 기본값 (현재 푸터와 동일) */
export const getFooterStatsFallback = () => [
  { value: '50+', label: '참여 대학 50개 이상' },
  { value: '10K+', label: '연계 기업 10K+' },
  { value: '4.8', valueSuffix: '★', valueSuffixColor: '#fbbf24', label: '평균 만족도 4.8' },
  { value: '4', label: 'AI 매칭 기술 특허 4건' }
];
